// src/pages/CompaniesList.jsx
import React, { useMemo, useState } from "react";
import {
  Box,
  Container,
  Stack,
  Heading,
  Text,
  Button,
  HStack,
  Input,
  SimpleGrid,
  Image,
  VStack,
  Badge,
  Flex,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { companies as ALL_COMPANIES } from "../../data/companies";
import TaxReliefForm from "../content/forms/TaxReliefForm";
import CompanyCard from "../content/companylist/CompanyCard";
import GenericContactForm from "../content/forms/GenericContactForm";
// src/pages/CompaniesList.jsx
export default function CompaniesList() {
  const [showForm, setShowForm] = useState(false);
  const [q, setQ] = useState("");
  const [specialty, setSpecialty] = useState("");

  const SPECIALTY_LABELS = {
    individual_1040: "Individuals / 1040",
    small_business: "Small Business",
    business: "Business",
    complex_corporate: "Complex Corporate",
    payroll_941: "Payroll 941",
    truckers_1099: "Truckers / 1099",
  };

  const heroOverlay = "rgba(0,0,0,0.55)";
  const heroBg = "/images/companies-bg.png";

  const cardBg = { base: "white", _dark: "gray.800" };
  const border = { base: "gray.200", _dark: "whiteAlpha.300" };
  const sub = { base: "gray.600", _dark: "gray.300" };

  const filtered = useMemo(() => {
    return ALL_COMPANIES.filter((c) => {
      const text = `${c.name} ${c.tagline || ""}`.toLowerCase();
      if (q && !text.includes(q.toLowerCase())) return false;
      if (specialty && !(c.specialties || []).includes(specialty)) return false;
      return true;
    });
  }, [q, specialty]);

  return (
    <>
      {/* HERO */}
      <Box
        position="relative"
        bgImage="url('/images/companies-bg.png')"
        bgPos={{ base: "center top", md: "center" }}
        bgSize="cover"
        bgRepeat="no-repeat"
        minH={{ base: "60vh", md: "70vh", lg: "75vh" }}
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          bg: heroOverlay,
        }}
      >
        <Container
          maxW="6xl"
          py={{ base: 10, md: 16 }}
          position="relative"
          zIndex={1}
          color="white"
        >
          {/* ✅ Title and Form in same flex container */}
          <Flex
            direction={{ base: "column", lg: "row" }}
            align={{ base: "flex-start", lg: "flex-start" }}
            justify="space-between"
            gap={{ base: 6, lg: 12 }}
            mb={{ base: 8, md: 12 }}
          >
            {/* Title */}
            <Heading
              as="h1"
              color="white"
              fontWeight="800"
              letterSpacing={{ base: "-0.02em", md: "-0.03em" }}
              lineHeight={{ base: "1.05", md: "1.05" }}
              fontSize={{ base: "5xl", md: "7xl", lg: "8xl", xl: "9xl" }}
              textShadow="0 2px 12px rgba(0,0,0,0.35)"
              flex="1 1 auto"
            >
              TAX RELIEF COMPANIES
            </Heading>

            {/* Form - Aligned with title top */}
            <Box
              flex="0 0 auto"
              w={{ base: "100%", lg: "450px" }}
              display="flex"
              justifyContent={{ base: "center", lg: "flex-end" }}
            >
              <GenericContactForm />
            </Box>
          </Flex>

          {/* Content below title */}
        </Container>
      </Box>

      {/* MAIN - Rest stays the same */}
      <Box py={{ base: 10, md: 14 }}>
        <Container maxW="6xl">
          <Stack spacing={6}>
            <Box id="companies">
              <Heading size="lg" mb={2}>
                All Providers
              </Heading>

              <HStack
                spacing={3}
                borderWidth="1px"
                borderColor={border}
                rounded="lg"
                p={3}
                mb={6}
                wrap="wrap"
                align="center"
              >
                <Input
                  placeholder="Search company name or tagline…"
                  maxW="320px"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                />
                <select
                  placeholder="All specialties"
                  onChange={(e) => setSpecialty(e.target.value)}
                >
                  <option value="">All specialties</option>
                  {Object.entries(SPECIALTY_LABELS).map(([key, label]) => (
                    <option key={key} value={key}>
                      {label}
                    </option>
                  ))}
                </select>
                <Text ml="auto" fontSize="sm" color={sub}>
                  {filtered.length} result{filtered.length === 1 ? "" : "s"}
                </Text>
              </HStack>

              <Stack spacing={6} align="center">
                {filtered.map((c, i) => {
                  return <CompanyCard key={c.key} item={c} rank={i + 1} />;
                })}
              </Stack>
            </Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
